
/* @flow */
import React, {PropTypes} from 'react';
import Translate from 'react-translate-component';
import WorkDatePickerContainer from './work-date-picker-container';
import WorkDateHelper from './work-date-helper';
import { ToggleDisplay, ConfirmModal, CloseModal, ToolTip, ExceededWorkingHoursModal } from 'components';
import InvoiceValidator from 'redux/modules/invoice/invoice-validator';
import { hasExceededWorkingHours } from '../../invoice-tool/invoice-tool-helper';
import moment from 'moment';
import { proxyCounterpart } from '../../../scripts/proxyCounterpart';
import _ from 'lodash';
import 'moment/locale/sv';
import 'moment/locale/en-gb';

export class WorkDate extends React.Component {

  static propTypes = {
    setInvoiceDate: PropTypes.func.isRequired,
    invoiceDate: PropTypes.array.isRequired,
    submitted: PropTypes.bool.isRequired,
    setDisplayDates: PropTypes.func.isRequired,
    setDisplayHours: PropTypes.func.isRequired,
    displayDates: PropTypes.number.isRequired,
    displayHours: PropTypes.number.isRequired,
    translationPrefix: PropTypes.string.isRequired,
    registerAssignmentTool: PropTypes.bool.isRequired
  };

  constructor (props) {
    super(props);

    this.state = {
      workDates: [],
      workDatesWithFutureDates: [],
      selectedDays: [],
      displayDates: 0,
      displayHours: 0,
      renderConfirmModal: false,
      renderExceededWorkingHoursModal: false,
      acceptedExceededWorkingHours: false,
      futureWorkDateMessageShown: false,
      totalWorkHours: '0',
      readMoreHoursModalOpen: false
    };

    this.onChangeShowDate = this.onChangeShowDate.bind(this);
    this.onChangeShowHour = this.onChangeShowHour.bind(this);
    this.openModal = this.openModal.bind(this);
    this.saveWorkDates = this.saveWorkDates.bind(this);
    this.renderWorkDate = this.renderWorkDate.bind(this);
    this.onCloseConfirmModal = this.onCloseConfirmModal.bind(this);
    this.onCloseExceededWorkingHoursModal = this.onCloseExceededWorkingHoursModal.bind(this);
    this.openConfirmModal = this.openConfirmModal.bind(this);
    this.renderConfirmModal = this.renderConfirmModal.bind(this);
    this.renderExceededWorkingHoursModal = this.renderExceededWorkingHoursModal.bind(this);
    this.selectDays = this.selectDays.bind(this);
    this.removeDays = this.removeDays.bind(this);
    this.editWorkHours = this.editWorkHours.bind(this);
    this.toggleReadMoreHoursModal = this.toggleReadMoreHoursModal.bind(this);
    this.renderReadMoreHoursModal = this.renderReadMoreHoursModal.bind(this);
  }

  componentWillReceiveProps (props) {
    let selectedDays = WorkDateHelper.parseWorkDates(props.invoiceDate);

    this.setState({
      workDates: props.invoiceDate,
      displayDates: props.displayDates,
      displayHours: props.displayHours,
      selectedDays: selectedDays,
      renderExceededWorkingHoursModal: this.props.registerAssignmentTool
        ? hasExceededWorkingHours(selectedDays)
        : false
    }, this.getTotalWorkHours());
  }

  onChangeShowDate (e) {
    let displayDates = parseInt(e.currentTarget.value);
    /**
    * We are not allowed to display hours if we don't display dates
    */
    if (displayDates === 0) {
      this.props.setDisplayHours(0);
    }
    this.props.setDisplayDates(displayDates);
  }

  onChangeShowHour (e) {
    this.props.setDisplayHours(parseInt(e.currentTarget.value));
  }

  openModal (e) {
    e.preventDefault();
  }

  openConfirmModal () {
    this.setState({
      renderConfirmModal: true
    });
  }

  onCloseConfirmModal (responsValue) {
    if (responsValue) {
      this.doSaveWorkDates(this.state.workDatesWithFutureDates);
    } else {
      this.removeDays(this.state.workDatesWithFutureDates);
    }
    this.setState({
      renderConfirmModal: false
    });
  }

  onCloseExceededWorkingHoursModal () {
    this.setState({
      renderExceededWorkingHoursModal: false,
      acceptedExceededWorkingHours: true
    });
  }

  selectDays (selectedDay) {
    this.state.selectedDays.push(selectedDay);
    this.doSaveWorkDates();
    this.getTotalWorkHours();
  }
  removeDays (days) {
    days.forEach((day) => {
      if (!day.displayDate) {
        day.displayDate = day.date;
      }
      const dayIndex = this.state.selectedDays.findIndex(sday => sday.displayDate === day.displayDate);

      if (dayIndex !== -1) {
        this.state.selectedDays.splice(dayIndex, 1);
      }
    });

    this.doSaveWorkDates();
    this.getTotalWorkHours();
  }
  editWorkHours (daysIndex, workHours) {
    let selectedDays = this.state.selectedDays;
    if (workHours < 0.01) workHours = 0.01;
    if (workHours > 24.00) workHours = 24.00;
    selectedDays[daysIndex].workHours = workHours;
    this.setState({
      selectedDays: selectedDays
    }, this.doSaveWorkDates());
  }
  getTotalWorkHours () {
    if (this.state !== null) {
      let workHours = 0;
      for (let i = 0; i<this.state.selectedDays.length; i++) {
        let startDate = moment(this.state.selectedDays[i].startDate);
        let endDate = moment(this.state.selectedDays[i].endDate);
        workHours += (endDate.diff(startDate, 'days') + 1) * this.state.selectedDays[i].workHours;
      }
      this.setState({
        totalWorkHours: workHours.toFixed(2)
      });
    }
  }
  doSaveWorkDates (extraDays = []) {
    let workDates = [];
    this.state.selectedDays.forEach((selectedDay) => {
      let startDate = moment(selectedDay.startDate);
      workDates.push({
        'hours': selectedDay.workHours,
        'date': startDate.format('YYYY-MM-DD')
      });
    });

    workDates = _.orderBy(workDates, 'date', 'asc');

    if (extraDays.length > 1) {
      extraDays.forEach((extraDay) => {
        if (!workDates.find(workDate => workDate.date === extraDay.date)) {
          workDates.push(extraDay);
          this.state.selectedDays.push(extraDay);
        }
      });
    }
    this.saveWorkDates(workDates);
  }
  saveWorkDates (workDates) {
    if (this.checkForFutureDates(workDates) &&
      !this.state.futureWorkDateMessageShown &&
      !this.props.registerAssignmentTool) {
      this.openConfirmModal();
    } else {
      this.setState({
        workDates: workDates
      });
      this.props.setInvoiceDate(workDates);
    }
  }
  checkForFutureDates (workDates) {
    const futureWorkDates = [];
    workDates.forEach((day) => {
      if (moment().isBefore(day.date)) {
        futureWorkDates.push(day);
      }
    });
    if (futureWorkDates.length) {
      this.setState({
        workDatesWithFutureDates: futureWorkDates,
        futureWorkDateMessageShown: true
      });
      return true;
    }
    return false;
  }

  renderError () {
    if (this.props.submitted && !InvoiceValidator.validateInvoiceDate(this.props.invoiceDate)) {
      return (
        <p className="error"><Translate content='INVOICE_ERROR_INVOICEDATE'/></p>
      );
    }
    if (this.props.submitted && !InvoiceValidator.validateMaxHours(this.props.invoiceDate)) {
      return (
        <p className="error"><Translate content='INVOICE_ERROR_INVOICEDATE_MAX_HOURS'/></p>
      );
    }
  }

  renderConfirmModal () {
    if (this.state.renderConfirmModal) {
      return (
        <ConfirmModal
          callback={this.onCloseConfirmModal}
          message={proxyCounterpart('FUTURE_WORK_DATE')}
          confirmButtonProps={{className: 'btn outlined white'}}
          confirmButtonText={proxyCounterpart('ACCEPT_FUTURE_DATES')}
          rejectButtonProps={{className: 'btn'}}
          rejectButtonText={proxyCounterpart('BACK')}
          reversedButtonOrder
        />
      );
    }
  }

  renderExceededWorkingHoursModal () {
    if (this.state.renderExceededWorkingHoursModal && !this.state.acceptedExceededWorkingHours) {
      return (
        <ExceededWorkingHoursModal
          callback={this.onCloseExceededWorkingHoursModal}
        />
      );
    }
  }

  renderDatePickerContainer () {
    return (
      <WorkDatePickerContainer
        workDates={this.state.workDates}
        saveWorkDates={this.saveWorkDates}
        selectedDays={this.state.selectedDays}
        selectDays={this.selectDays}
        removeDays={this.removeDays}
        editWorkHours={this.editWorkHours}
        totalWorkHours={this.state.totalWorkHours}
      />
    );
  }

  renderActions () {
    return (
      <div className='show-date-hours-wrapper'>
        <div className="show-date-wrapper">
          <div className='radio-btn-wrapper'>
            <p><Translate content='SHOW_DATE'/></p>
            <div className="show-date-input">
              <input id='show-date-alt-1' type='radio' name='show-date' value={1}
                checked={this.props.displayDates === 1}
                onChange={this.onChangeShowDate}/>
              <label htmlFor='show-date-alt-1'><span></span><Translate content='YES'/></label>

              <input id='show-date-alt-2' type='radio' name='show-date' value={0}
                checked={this.props.displayDates === 0}
                onChange={this.onChangeShowDate}/>
              <label htmlFor='show-date-alt-2'><span></span><Translate content='NO'/></label>
            </div>
          </div>
          <ToggleDisplay show={(this.props.displayDates === 1)}>
            <div className='radio-btn-wrapper'>
              <p><Translate content='INVOCETOOL_SHOW_HOURS'/></p>
              <div className="show-date-input">
                <input id='show-hour-alt-1' type='radio' name='show-hour' value={1}
                  checked={this.props.displayHours === 1}
                  onChange={this.onChangeShowHour}/>
                <label htmlFor='show-hour-alt-1'><span></span><Translate content='YES'/></label>

                <input id='show-hour-alt-2' type='radio' name='show-hour' value={0}
                  checked={this.props.displayHours === 0}
                  onChange={this.onChangeShowHour}/>
                <label htmlFor='show-hour-alt-2'><span></span><Translate content='NO'/></label>
              </div>
            </div>
          </ToggleDisplay>
        </div>
      </div>
    );
  }

  renderWorkDate (item, i) {
    return (
      <tr key={i}>
        <td>
          {item.displayDate}
        </td>
        <td>
          {item.totalHoursForPeriod}
        </td>
        <td>
          <i className='pen-link customer-link' onClick={this.openModal}></i>
        </td>
      </tr>
    );
  }

  toggleReadMoreHoursModal () {
    this.setState({
      readMoreHoursModalOpen: !this.state.readMoreHoursModalOpen
    });
  }

  renderReadMoreHoursModal () {
    if (this.state.readMoreHoursModalOpen) {
      return <CloseModal
        headline={proxyCounterpart('WORKING_HOURS_INFO_MODAL_TITLE')}
        body={proxyCounterpart('WORKING_HOURS_INFO_MODAL_BODY')}
        close={this.toggleReadMoreHoursModal}
      />;
    }
  }

  render () {
    return (
      <div className='work-date'>
        <h3>
          <Translate content='WORKED_TIME'/>
          <ToolTip id='workdate_hours-info' msg={proxyCounterpart('WORKDATE_HOURS_INFO')}/>
        </h3>
        <Translate
          content='WORK_DATE_TEXT'
          readMoreLink={
            <a onClick={this.toggleReadMoreHoursModal}>
              <b>
                <Translate
                  content='WORK_DATE_TEXT_LINK'
                />
              </b>
            </a>
          }
        />
        {this.renderDatePickerContainer()}
        {this.renderActions()}
        {this.renderError()}
        {this.renderConfirmModal()}
        {this.renderExceededWorkingHoursModal()}
        {this.renderReadMoreHoursModal()}
      </div>
    );
  }
}

export default WorkDate;



/** WEBPACK FOOTER **
 ** ./src/views/invoice-tool/work-date/work-date.js
 **/